import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ExemptionPolicyFields from './ExemptionPolicyFields'

export const ExemptionPolicyCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <ExemptionPolicyFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default ExemptionPolicyCreate
